import React from 'react';
import strings from '../../lang/strings.js';
import { PageSettings } from "../../config/page-settings";
import DataTable from './../../components/content/data-table.jsx';
import classnames from 'classnames';
import $ from 'jquery';
import './../../config/util';
import U from './../../config/util';
import Const from './../../config/const';
import MemberDetailPopup from './../member-detail/member-detail-popup'

class MeetingDetailMeeting extends React.Component {
    static contextType = PageSettings;

    constructor(props) {
        super(props);

        this.state = {
            user_id: 0,
            show_member_profile: false,
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.refreshTable = this.refreshTable.bind(this);
    }

    componentDidMount() {
    }

    toggleModal(result) {
        if (this.props.onClose) {
            this.props.onClose(result);
        }
    }

    refreshTable = (refresh) => {
        this.tblMember.draw(refresh);
    };

    showMemberDetailPopup(uid) {
        this.setState({
            show_member_profile: true,
            selected_uid: uid
        });
    }

    getData() {
        this.refreshTable(true);
    }

    deleteMeeting(id) {
        let self = this;
        this.context.showConfirm(strings.confirm_delete_title, function (response) {
            if (response) {
                self.context.post('meeting/deleteMeeting', { id }, function () {
                    self.context.addNotification('success', strings.alert_title, strings.confirm_delete_done);
                    self.refreshTable(false);
                }, true);
            }
        });
    }

    deleteUser(item) {
        let self = this;
        this.context.showConfirm(strings.confirm_delete_title, function (response) {
            if (response) {
                self.context.post('meeting/deleteMeetingUser', { id: item.id }, function () {
                    self.context.addNotification('success', strings.alert_title, strings.confirm_delete_done);
                    self.refreshTable(false);
                }, true);
            }
        });
    }

    render() {
        let self = this;
        let columnNo = 0;

        return (
            <div>
                <MemberDetailPopup isOpen={this.state.show_member_profile} uid={this.state.selected_uid} onClose={() => {
                    this.setState({ show_member_profile: false });
                }} />
                <div className='row'>
                    <div className='col-md-12 mt-3'>
                        <DataTable ref={(ref) => this.tblMember = ref}
                            options={{
                                columnDefs: [
                                    {
                                        targets: [columnNo++], data: 'id', orderable: false,
                                        render: function (value) {
                                            return value;
                                        }
                                    },
                                    {
                                        targets: [columnNo++], data: 'profile_image', orderable: false,
                                        createdCell: function (td, value, item) {
                                            $(td).image_lightbox(value, () => {
                                                self.context.showGallery([Const.BASE_URL + value])
                                            });
                                        }
                                    },
                                    {
                                        targets: [columnNo++], data: 'nickname', orderable: false,
                                        createdCell: function (td, value, item) {
                                            $(td).nickname_label(value, item.gender, () => {
                                                self.showMemberDetailPopup(item.uid);
                                            });
                                            if (item.alias) {
                                                $(td).append(`<br/>(${item.alias})`);
                                            }
                                        }
                                    },
                                    {
                                        targets: [columnNo++], data: 'create_date', orderable: false,
                                        render: function (value) {
                                            return value;
                                        }
                                    },
                                    {
                                        targets: [columnNo++], data: 'ok', orderable: false,
                                        createdCell: function (td, value, item) {
                                            if (item.ok == 0) {
                                                return $(td).html(strings.profile_open);
                                            }

                                            if (item.ok > 0 && item.reply_ok == 0) {
                                                return $(td).html(`<span style="color: blue">${strings.ok_sent}</span>`);
                                            }

                                            if (item.ok > 0 && item.reply_ok > 0) {
                                                return $(td).html(`<span style="color: red">${strings.match_success}</span>`);
                                            }

                                            return $(td).html('');
                                        }
                                    },
                                    {
                                        targets: [columnNo++], data: 'reply_date', orderable: false,
                                        render: function (value) {
                                            return value;
                                        }
                                    },
                                    {
                                        targets: [columnNo++], data: 'id', orderable: false,
                                        createdCell: function (td, value, item) {
                                            $(td).html('');
                                            $(td).append(`<button type='button' class='btn btn-danger btn-sm m-2'>${strings.delete}</button>`)
                                                .find('button:last')
                                                .on('click', function () {
                                                    self.deleteUser(item);
                                                });
                                        }
                                    }
                                ],
                                order: [[1, 'DESC']],
                                ajax: {
                                    url: 'meeting/getCardList',
                                    data: function (req) {
                                        req.columns = null;
                                        req.meeting_id = self.props.meeting_id;
                                    }
                                },
                                drawCallback: function () {
                                },
                                fnCreatedRow: function (row, data, dataInd) {
                                }
                            }}>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>{strings.profile}</th>
                                    <th>{strings.nickname}</th>
                                    <th>{strings.ok_date}</th>
                                    <th>{strings.match_result}</th>
                                    <th>{strings.match_date}</th>
                                    <th>{strings.manage}</th>
                                </tr>
                            </thead>
                            <tbody />
                        </DataTable>
                    </div>
                </div>
            </div >
        )
    }
}

export default MeetingDetailMeeting;